module.exports = __webpack_public_path__ + "img/APSicon2.b6484d94.png";